import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { DETAIL } from '../../../constants/props';

const useStyles = makeStyles({
  root: {
    '&:not(:last-child)': {
      marginBottom: '.9375rem',
    },
  },
  title: {
    fontSize: '1.375rem',
    lineHeight: '1.4rem',
  },
  subtitle: {
    fontSize: '1rem',
  },
});

const Detail = ({ icon, title, subtitle, detail }) => {
  const classes = useStyles();
  return (
    <Grid className={classes.root} container direction="row" spacing={2}>
      <Grid className={classes.title} item>
        {icon}
      </Grid>
      <Grid item container direction="column" xs>
        <Typography className={classes.title} variant="button">
          {title}
        </Typography>
        <Typography
          className={classes.subtitle}
          variant="caption"
          color="textSecondary"
        >
          {subtitle}
        </Typography>
      </Grid>
      {detail}
    </Grid>
  );
};

Detail.propTypes = {
  DETAIL,
};

export default Detail;
